import voucherReducer from './reducers';

export default voucherReducer;
